var React = require('react');

function RadioChecked (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("circle",{"cx":"12","cy":"12","r":"11","fill":"#FFFFFF","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("circle",{"className":"core","cx":"12","cy":"12","r":"5","fill":"currentColor","key":1})]));
}

RadioChecked.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 24 24"};

module.exports = RadioChecked;

RadioChecked.default = RadioChecked;
